<button *ngIf="showInstallButton"
        class="btn btn-success btn-block mt-3"
        (click)="instalarPWA()">
  <i class="fas fa-download mr-2"></i> Instalar Mesa de Ayuda
</button>
